import { useState } from 'react'
import { useAppSelector } from '../store/hooks'
import type { AppEvent } from '../store/statusSlice'
import './AppEventFeed.css'

const eventTypeLabels: Record<string, string> = {
  'container.started': 'STARTED',
  'container.stopped': 'STOPPED',
  'container.spawned': 'SPAWNED',
  'container.error': 'ERROR',
  'app.queued': 'QUEUED',
  'app.requeued': 'REQUEUED',
  'app.rejected': 'REJECTED',
  'spawn.check': 'CHECK',
  'spawn.trigger': 'SPAWN',
}

const eventTypeClasses: Record<string, string> = {
  'container.started': 'started',
  'container.stopped': 'stopped',
  'container.spawned': 'spawned',
  'container.error': 'error',
  'app.queued': 'queued',
  'app.requeued': 'requeued',
  'app.rejected': 'rejected',
  'spawn.check': 'check',
  'spawn.trigger': 'spawn',
}

function AppEventItem({ event }: { event: AppEvent }) {
  const label = eventTypeLabels[event.event_type] || event.event_type.toUpperCase()
  const cls = eventTypeClasses[event.event_type] || 'default'

  return (
    <div className="app-event-feed__item" data-testid="app-event-item">
      <span className="app-event-feed__time" data-testid="app-event-timestamp">
        {new Date(event.created_at).toLocaleString()}
      </span>
      <span className={`app-event-feed__badge app-event-feed__badge--${cls}`} data-testid={`app-event-badge-${cls}`}>{label}</span>
      <span className="app-event-feed__message">{event.message}</span>
    </div>
  )
}

function AppEventFeed() {
  const appEvents = useAppSelector((state) => state.status.appEvents)
  const [collapsed, setCollapsed] = useState(false)

  return (
    <section className="app-event-feed" data-testid="app-event-feed" aria-labelledby="app-event-feed-heading">
      <h2 className="sr-only" id="app-event-feed-heading">Recent App Events</h2>
      <button
        type="button"
        className="app-event-feed__title"
        data-testid="app-event-feed-toggle"
        aria-expanded={!collapsed}
        onClick={() => setCollapsed(!collapsed)}
      >
        <span>Recent App Events</span>
        <span className="app-event-feed__toggle-icon" aria-hidden="true">{collapsed ? '+' : '\u2013'}</span>
      </button>
      {!collapsed && (
        appEvents.length === 0 ? (
          <p className="app-event-feed__empty" data-testid="app-event-feed-empty">
            No app events yet
          </p>
        ) : (
          <ul className="app-event-feed__list" role="list">
            {appEvents.map((event) => (
              <li key={event.id}>
                <AppEventItem event={event} />
              </li>
            ))}
          </ul>
        )
      )}
    </section>
  )
}

export default AppEventFeed
